import React, { useState } from 'react';
import { Box, IconButton, Input, InputAdornment, TextField, Typography } from '@mui/material';
import { Check, Close, Edit, EditAttributes, Email as EmailIcon } from '@mui/icons-material';
import ActionButton from '../../../core/components/ui/ActionButton';

interface EmailInitiationStepProps {
  email: string;
  isLoading: boolean;
  onSendEmailCode: (arg: string) => void;
}

const EmailInitiationStep: React.FC<EmailInitiationStepProps> = ({
  email,
  isLoading,
  onSendEmailCode,

}) => {
  const [isEditable, setEditable] = useState(true);
  const [newEmail, setEmail] = useState(email);
  const [error, setError] = useState('');
  const [isError, setIsError] = useState(false);
  const isValidEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };
  const handleSendEmailCode = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!isValidEmail(newEmail)) {
      setError('Invalid email address');
      setIsError(true);
      return;
    }
    onSendEmailCode(newEmail);
  }
  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
    setError('');
    setIsError(false);
  }
  return (
    <form onSubmit={handleSendEmailCode}>
      <Box sx={{ textAlign: 'center', py: 2 }}>
        <EmailIcon sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />

        <Typography variant="h6" gutterBottom>
          Verify Your Email
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          Your phone number has been verified!
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Now we need to verify your email address:
        </Typography>

        {/* <Box sx={{
        backgroundColor: 'background.paper',
        p: 2,
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'divider',
        mb: 3
      }}> */}
        <TextField value={newEmail} fullWidth sx={{ textAlign: 'center' }}
          error={isError}
          helperText={error}
          disabled={isEditable}
          onChange={handleEmailChange}
          type='email'
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton onClick={() => setEditable(!isEditable)}>
                    {isEditable ? <Edit /> : <Check />}
                  </IconButton>
                </InputAdornment>
              )
            }
          }} />
         
        {/* <Typography variant="body1" fontWeight="medium">
          {email}
        </Typography> */}
        {/* </Box> */}

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Click the button below to receive a verification code at this email address.
        </Typography>

        <ActionButton
          text="Send Code to Email"
          loading={isLoading}
          //onClick={()=>onSendEmailCode(newEmail)}
          type='submit'
          testId="send-email-code-button"
        />
      </Box>
    </form>
  );
};

export default React.memo(EmailInitiationStep);